type Matcher<T extends Element> = (element: T) => boolean;

export const matchSrc = (regExp: RegExp) => ({ src }: HTMLIFrameElement): boolean => !!src.match(regExp);

export const matchClass = (className: string) => (el: Element): boolean => el.classList.contains(className);

export const matchId = (id: string) => (el: Element): boolean => id === el.id;

export const matchAttr = (attr: string, value: string) => (el: Element): boolean => el.getAttribute(attr) === value;

export const findMatchedIframe = <T extends Element>(matcher: Matcher<T>) => findDomElement('iframe', matcher);

function findDomElement<T extends Element>(selector: string, matcher: Matcher<T>) {
  const elements = [...document.querySelectorAll<T>(selector)];

  return elements.find((el) => matcher(el));
}

export function matchAny<T extends Element>(matchers: Array<Matcher<T>>) {
  return (element: T): boolean => !!matchers.find((matcher) => matcher(element));
}
